// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1pcHA","inputWrap":"styles_inputWrap__1qi2-","input":"styles_input__C2Jow"};